import { render, staticRenderFns } from "./PropertyRepairDialog.vue?vue&type=template&id=62c3c86e&scoped=true&"
import script from "./PropertyRepairDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyRepairDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRepairDialog.vue?vue&type=style&index=0&id=62c3c86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3c86e",
  null
  
)

export default component.exports